export default {
    title: 'Comment - What makes this company micro-trend so special?'
}
